import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import * as React from 'react';
import classNames from 'classnames';
import { Close } from '@livingdesign/icons';
import { componentOverlayCloseButtonIconSize } from '@livingdesign/tokens/dist/js/light/regular/components/Overlay';
import styles from './OverlayCloseButton.module.scss.js';
import { applyCommonProps } from '../utility/commonProps.js';

var _excluded = ["children", "className"];
/**
 * @private
 */
var OverlayCloseButton = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _applyCommonProps = applyCommonProps(props, OverlayCloseButton);
    _applyCommonProps.children;
    var className = _applyCommonProps.className,
    rest = _objectWithoutProperties(_applyCommonProps, _excluded);
  return /*#__PURE__*/React.createElement("button", _extends({
    "aria-label": "Close dialog",
    className: classNames(styles.closeButton, className),
    ref: ref,
    type: "button"
  }, rest), /*#__PURE__*/React.createElement(Close, {
    size: componentOverlayCloseButtonIconSize
  }));
});
OverlayCloseButton.displayName = 'OverlayCloseButton';

export { OverlayCloseButton };
